const sendContactRequest = async (formData) => {
  const data = new FormData();

  data.append("name", formData.name);
  data.append("email", formData.email);
  data.append("phone", formData.phone);
  data.append("division", formData.division);
  data.append("service", formData.service || "");
  data.append("equipment", formData.equipment || "");
  data.append("message", formData.message);

  if (formData.files && formData.files.length > 0) {
    data.append("attachment", formData.files[0]);
  }

  // Si es local
//   const response = await fetch(
//     "http://localhost/websitegsa/server/api/send-contact.php",
//     {
//       method: "POST",
//       body: data,
//     },
//   );

  // Servidor
  const response = await fetch("/server/api/send-contact.php", {
  method: "POST",
  body: data,
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || "No fue posible enviar la solicitud.");
  }

  return result;
};

export default sendContactRequest;
